// material-ui
import { Box, FormControl } from '@mui/material';


// ==============================|| HEADER CONTENT - SEARCH ||============================== //

const Search = () => (
  <Box sx={{ flexShrink: 0, width: { xs: '100%', md: 224 }, ml: { xs: 0, md: 1 } }}>
    <FormControl sx={{ width: '100%' }}>
      
    </FormControl>
  </Box>
);

export default Search;
